module.exports = __webpack_public_path__ + "static/media/COALINDIA_F1.2888ad78.txt";